// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a75af107","534":"05a4a9e0","640":"a1a86c78","685":"25fc0f34","846":"951e05aa","868":"f3143a5d","877":"acf88263","909":"bbfe2999"}[chunkId] + ".chunk.js";
};